import {outter_post} from 'common/js/axios-helper';
import {TatMemRewardsApi} from "./constant/UrlMapper";


const host = '8880';
const tatMemRewardsAdd = (data) => {
    return outter_post(TatMemRewardsApi.TatMemRewardsAdd, data, host);
};

const tatMemRewardsDetail = (data) => {
    return outter_post(TatMemRewardsApi.TatMemRewardsDetail, data, host);
};

const tatMemRewardsRuleAdd = (data) => {
    return outter_post(TatMemRewardsApi.TatMemRewardsRuleAdd, data, host);
};

const tatMemRewardsRuleDetail = (data) => {
    return outter_post(TatMemRewardsApi.TatMemRewardsRuleDetail, data, host);
};

const tatMemRewardsRuleEdit = (data) => {
    return outter_post(TatMemRewardsApi.TatMemRewardsRuleEdit, data, host);
};

const getTatRank = (data) => {
    return outter_post(TatMemRewardsApi.GetTatRank, data, host);
};



export default {
    tatMemRewardsAdd,
    tatMemRewardsDetail,
    tatMemRewardsRuleAdd,
    tatMemRewardsRuleDetail,
    tatMemRewardsRuleEdit,
    getTatRank,
}



// WEBPACK FOOTER //
// ./src/service/TatMemRewardsService.js